export default "__VITE_ASSET__D0WZBbHC__"